import * as React from "react";
import clockIcon from '../assets/images/clock.svg';
import { useState } from "react";
import { DataGrid, GridOverlay } from "@mui/x-data-grid";
import CircularProgress from "@mui/material/CircularProgress";
import { useEffect } from "react";
import { getActionType, getHistoryActionLogs } from "../services/commonService";
import { ActionLogItem } from "./ActionLogItem";
import { useSelector } from "react-redux";
import { HistoryTabFilters } from "../pages/historyTab/HistoryTabFilters";

const PAGE_SIZE = 20;

export const HistoryActionLogs = ({ estate }) => {

    const [actionLogsList, setActionLogsList] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const [isLoadingMore, setIsLoadingMore] = useState(false);
    const [viewDetailShow, setViewDetailShow] = useState(false);

    const [actionTypeList, setActionTypeList] = useState([]);
    const [selectedActionType, setSelectedActionType] = useState("");
    const [startDate, setStartDate] = useState("");
    const [endDate, setEndDate] = useState("");
    const [performBy, setPerformBy] = useState("");

    const [pageNumber, setPageNumber] = useState(1);
    const [hasMore, setHasMore] = useState(false);

    const reduxProperty = useSelector(state => state.selectedProperty.selectedProperty);

    const onActionTypeChange = (val) => {
        setSelectedActionType(val);
    }

    const onStartDateChange = (val) => {
        setStartDate(val);
    }

    const onEndDateChange = (val) => {
        setEndDate(val);
    }

    const onPerformByChange = (val) => {
        setPerformBy(val);
    }

    // Fetch page 1 whenever the estate or any filter changes — replaces the list
    useEffect(() => {
        if (estate) {
            const getActionLogs = async () => {
                setIsLoading(true);
                setPageNumber(1);

                let actionLogsObj = {
                    estateId: estate.id,
                    actionLogId: 0,
                    actionType: selectedActionType,
                    performBy: performBy,
                    startDate: startDate,
                    endDate: endDate,
                    pageNumber: 1,
                    pageSize: PAGE_SIZE
                }

                const actionLogs = await getHistoryActionLogs(actionLogsObj);
                if (actionLogs?.data) {
                    setActionLogsList(actionLogs.data);
                    setHasMore(actionLogs.data.length === PAGE_SIZE);
                } else {
                    setActionLogsList([]);
                    setHasMore(false);
                }

                const actionType = await getActionType();
                if (actionType) {
                    setActionTypeList(actionType);
                }

                setIsLoading(false);
            }
            getActionLogs();
        }

    }, [estate, selectedActionType, performBy, startDate, endDate]);

    // Fetches the next page and appends it — does not touch existing rows
    const handleLoadMore = async () => {
        if (!estate || isLoadingMore) return;

        setIsLoadingMore(true);
        const nextPage = pageNumber + 1;

        let actionLogsObj = {
            estateId: estate.id,
            actionLogId: 0,
            actionType: selectedActionType,
            performBy: performBy,
            startDate: startDate,
            endDate: endDate,
            pageNumber: nextPage,
            pageSize: PAGE_SIZE
        }

        const actionLogs = await getHistoryActionLogs(actionLogsObj);
        if (actionLogs?.data?.length > 0) {
            setActionLogsList(prev => [...prev, ...actionLogs.data]);
            setPageNumber(nextPage);
            setHasMore(actionLogs.data.length === PAGE_SIZE);
        } else {
            setHasMore(false);
        }

        setIsLoadingMore(false);
    };

    const handleClearFilters = () => {
        setSelectedActionType("");
        setStartDate("");
        setEndDate("");
        setPerformBy("");
    };

    return (
        <>
            <div>
                <HistoryTabFilters
                    actionType={actionTypeList}
                    selectedActionType={selectedActionType}
                    onActionTypeChange={onActionTypeChange}
                    startDate={startDate}
                    endDate={endDate}
                    onStartDateChange={onStartDateChange}
                    onEndDateChange={onEndDateChange}
                    performBy={performBy}
                    onPerformByChange={onPerformByChange}
                    onClearFilters={handleClearFilters}
                />
                <ActionLogItem actionLogsList={actionLogsList} isLoading={isLoading} viewDetailShow={viewDetailShow} setViewDetailShow={setViewDetailShow} estateId={estate.id} />

                {!isLoading && hasMore && (
                    <div className="d-flex justify-content-center mt-3 mb-3">
                        <button
                            className="site-btn"
                            onClick={handleLoadMore}
                            disabled={isLoadingMore}
                        >
                            {isLoadingMore ? "Loading..." : "Load More"}
                        </button>
                    </div>
                )}
            </div>

        </>
    )
}

